var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "10px",
    viewBox: "0 0 26 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Redo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workspace---Scan-List",
    transform: "translate(-378.000000, -123.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.225,123 C384.92125,123 380.363789,126.150664 378.296289,130.680664 C377.986289,131.359414 378.330977,132.160722 379.038477,132.396973 C379.637227,132.596972 380.290899,132.315235 380.552149,131.740235 C382.222148,128.060235 385.92125,125.5 390.225,125.5 C392.947624,125.5 395.42114,126.537105 397.300195,128.222168 L393.589258,131.933105 C393.345508,132.176855 393.345508,132.573145 393.589258,132.816895 C393.711758,132.938145 393.871153,133 394.031153,133 L402.156153,133 C402.846508,133 403.406153,132.440356 403.406153,131.75 L403.406153,123.625 C403.406153,123.465 403.345546,123.304355 403.223048,123.183105 C402.979296,122.939356 402.583008,122.939356 402.339258,123.183105 L399.060449,126.461914 C396.731445,124.321285 393.64003,123 390.225,123 Z",
    id: "Redo"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.2988270d5d71d470f29f7d508f8f29a1.svg";
export { ForwardRef as ReactComponent };